__turbopack_context__.v({
  "pulse": "skeleton-module-scss-module__3L-RpG__pulse",
  "skeleton": "skeleton-module-scss-module__3L-RpG__skeleton",
});
